export default __webpack_public_path__ + "8b615369c80e614cda8672fde5c20f5f.svg";